

































import { Component, Vue } from "vue-property-decorator";

export default Vue.extend({
    data(){
      return {
        active: Boolean,
        disturbance: false,
        driftstorningar: {},
        // driftstorningar: {"drift":[{"beskrivning":"En liten beskrivning av denna driftstörningen","datum":"2021-05-07","färg":"success","ikon":"mdi-check","senasteändring":"2021-05-07 15:11:26","status":"Åtgärdad","tid":"2021-05-07 13:19:37","titel":"Ny driftstörning"},{"beskrivning":"Driften är nu igång på alla system","datum":"2021-05-07","färg":"error","ikon":"mdi-alert-circle","senasteändring":"2021-05-07 15:04:30","status":"Pågående","tid":"2021-05-07 13:20:06","titel":"Avklarad"}]}
      }
    },
    components: {},
    methods: {
        async getData(){
            const myHeaders = new Headers({
                'Content-Type': 'application/json'
                });
            await fetch(this.$store.state.URLJSON+'drift.json',{
                headers: myHeaders
                })
            .then((r) => r.json())
            .then((res) => {
            //   console.log(res);
              this.driftstorningar = res;
                // const temp = [res.drift];
                // console.log('res.drift',res.drift);
                // console.log('temp',temp)

                // for (var i = 0; i < temp[0].length; i++) {
                //     const statusCheck = temp[i][i].status
                //     console.log('temp[i]',temp[i]);
                //     console.log('i',i);
                //     console.log('statusCheck',statusCheck);
                //     if(statusCheck === "Pågående"){
                //         console.log('PÅGEÅNDE');
                //         this.disturbance = true;
                //         break
                //     }
                    

                // }
           
              });
        },
    },
    mounted(){
        this.getData()
    }
})
